import noop from './noop';
import getEventTargetIndex from './get-event-target-index';
import validation from './validation';
import getURLProtocolScheme, { PROTOCOL_SCHEMES } from './get-url-protocol-scheme';
import forceHTTPS from './force-https';
import preventBodyScroll from './ios-workarounds/prevent-body-scroll';
import handleAsyncError from './handle-async-error';
import hasUrlOrigin from '../core/utils/helpers/has-url-origin';
import isAbsoluteURL from './is-absolute-url';
import isNumeric from './is-numeric';
import escapeHTML from './escape-html';
import unescapeHTML from './unescape-html';
import pollAsyncJob from './poll-async-job';

export default {
  noop,
  getEventTargetIndex,
  getURLProtocolScheme,
  forceHTTPS,
  PROTOCOL_SCHEMES,
  validation,
  preventBodyScroll,
  handleAsyncError,
  hasUrlOrigin,
  isAbsoluteURL,
  isNumeric,
  escapeHTML,
  unescapeHTML,
  pollAsyncJob,
};
